import { defineStore } from 'pinia'
import useCrudStore from '@/hooks/useCrudStore'
import {
  fetchItems,
  fetchItem,
  createItem,
  updateItem,
  destroyItem,
  bulkUpdate
} from '@/apps/traforama/api/ipLists'
import { IIPBulkUpdateAttributes } from '@/apps/traforama/interfaces/ipLists'

const defaultFilter = { title: '' }

export const useIPListsStore = defineStore('ipLists', () => {
  const {
    currentItems,
    total,
    filter,
    selected,
    items,
    current,
    listLoading,
    itemsLoading,
    currentPage,
    FetchItems,
    FetchItem,
    SaveItem,
    DestroyItem,
    SetCurrentPage,
    SetSelection,
    SetFilters,
    SetCurrent,
    error,
    itemById,
    payload,
    setItems,
    setCurrentItems,
    setTotal,
    removeItem
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    fetchItem,
    createItem,
    updateItem,
    destroyItem
  })

  const BulkUpdate = async (item: IIPBulkUpdateAttributes) => {
    listLoading.value = true
    try {
      const response = await bulkUpdate(item)
      return response.data
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  const DestroyItems = async (ids: string[]) => {
    listLoading.value = true
    try {
      await Promise.all(ids.map((id) => destroyItem(id)))
      ids.forEach((id) => removeItem(id))
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  return {
    // State
    currentItems,
    filter,
    total,
    currentPage,
    listLoading,
    selected,
    current,

    // Actions
    SetFilters,
    FetchItems,
    SaveItem,
    SetCurrentPage,
    DestroyItem,
    SetCurrent,
    DestroyItems,
    BulkUpdate,
    FetchItem,
    SetSelection
  }
})
